import { Trans, useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'
import { MoveToDraftOpportunityModalProps } from './MoveToDraftOpportunityModal.types'

export function MoveToDraftOpportunityModal({
  open,
  handleClose,
  handleMoveToDraftOpportunity,
  isLoading,
  opportunityName
}: Readonly<MoveToDraftOpportunityModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose} data-testid="move-to-draft-opportunity-modal">
      <ActionModal
        title={t('typography.volunteering.moveToDraftOpportunity.title')}
        primaryButtonText={t('typography.yesMoveToDraft')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={handleMoveToDraftOpportunity}
        loading={isLoading}
      >
        <Trans
          i18nKey="typography.volunteering.moveToDraftOpportunity.description"
          components={{ b: <b /> }}
          values={{ opportunityName }}
        />
      </ActionModal>
    </Modal>
  )
}
